import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Checkbox, Radio } from 'tea-component';
import { useIntl } from 'umi';
import {
  ACCUMULATED_TEXT,
  ACCUMULATED_VALUE,
} from './constant';

import './index.scss';
import CommonBubble from '@home/components/CommonBubble';
import SvgIcon from '@home/components/SvgIcon';

function DimensionAccumulateRow(props) {
  const { value = [], options = [], onChange, className = '' } = props;
  const { formatMessage } = useIntl();
  const [radioValue, setRadioValue] = useState(true);
  const [checkValue, setCheckValue] = useState([]);
  const [hover, setHover] = useState(false);
  const bindClassName = useRef(
    'dimension-accumulate-' + Date.now().toString(36),
  );
  useEffect(() => {
    setRadioValue(value.includes(ACCUMULATED_VALUE));
    setCheckValue(value);
  }, [value]);

  const handleCheckoutChange = (value) => {
    onChange(value);
  };

  return (
    <div className="selector-multiple__row">
      <div className='title'>
        <span className='label'>{formatMessage({ id: "common_Dimension" })}</span>
      </div>
      <Checkbox.Group
        layout="inline"
        value={checkValue}
        className="row"
        onChange={handleCheckoutChange}
      >
        {options?.map((item) => (
          <>
            <Checkbox
              key={item.value}
              name={item.value}
              disabled={item.disabled && value.includes(item.value)}
            >
              <span dangerouslySetInnerHTML={{ __html: `${item.text}` }} />

            </Checkbox>
            {
              item?.info && <CommonBubble
                placement="top"
                content={item?.info}
                className='dbd-table-dimension-port-info'
              >
                <i className='dbd-table-dimension-port-icon' onMouseOver={() => { setHover(true) }} onMouseOut={() => { setHover(false) }}>
                  <SvgIcon  type={hover ? 'alert-circle-action' : 'alert-circle-m'} />
                </i>
              </CommonBubble>
            }
          </>
        ))}
      </Checkbox.Group>
    </div>
  );
}

export default DimensionAccumulateRow;
export { ACCUMULATED_TEXT, ACCUMULATED_VALUE };
